/**
 * Phonics Letter Ii — 课程数据配置
 * 媒体资源：/media/phonics/ii/
 */

const MEDIA_BASE = '/media/phonics/ii';
const V = 'v2';

export const letterData = {
  letter: 'I',
  title: 'Phonics',
  subtitle: 'Letter Ii',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频
  songVideo: {
    src: `${MEDIA_BASE}/Ii.mp4?${V}`,
    startTime: 9,
    endTime: 92,
  },

  // Step 2: 4格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_ink.mp4?${V}`,    cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_iguana.mp4?${V}`,  cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_insect.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_igloo.mp4?${V}`,  cover: `${MEDIA_BASE}/image12.png?${V}` },
  ],

  // storySections 包含：vocab教学(左右) + 故事(video-top-lines-bottom) + Chant
  storySections: [

    // vocab (1): draw + what's wrong — PPT P8 双视频左右两栏
    {
      label: 'Learn the words (1)',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words1_draw.mp4?${V}`,   poster: `${MEDIA_BASE}/image13.png?${V}` },
        { src: `${MEDIA_BASE}/video_words1_wrong.mp4?${V}`,  poster: `${MEDIA_BASE}/image14.png?${V}` },
      ],
      splitAt: 2,
      lines: [
        // 左视频台词：draw / drawing
        { en: 'draw',       cn: '画画',     audioEn: `${MEDIA_BASE}/w_en_draw.mp3?${V}`,      audioCn: `${MEDIA_BASE}/w_cn_draw.mp3?${V}` },
        { en: 'drawing',    cn: '在画画',   audioEn: `${MEDIA_BASE}/w_en_drawing.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_drawing.mp3?${V}` },
        // 右视频台词：wrong / what's wrong?
        { en: 'wrong',      cn: '出错',     audioEn: `${MEDIA_BASE}/w_en_wrong.mp3?${V}`,     audioCn: `${MEDIA_BASE}/w_cn_wrong.mp3?${V}` },
        { en: "what's wrong?", cn: '出什么问题了？', audioEn: `${MEDIA_BASE}/s_en_whats_wrong.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_whats_wrong.mp3?${V}` },
      ],
    },

    // vocab (2): eat + sleep — PPT P9 双视频左右两栏
    {
      label: 'Learn the words (2)',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words2_eat.mp4?${V}`,    poster: `${MEDIA_BASE}/image16.png?${V}` },
        { src: `${MEDIA_BASE}/video_words2_sleep.mp4?${V}`,  poster: `${MEDIA_BASE}/image15.png?${V}` },
      ],
      splitAt: 2,
      lines: [
        // 左视频台词：eat / eating
        { en: 'eat',       cn: '吃饭',    audioEn: `${MEDIA_BASE}/w_en_eat.mp3?${V}`,        audioCn: `${MEDIA_BASE}/w_cn_eat.mp3?${V}` },
        { en: 'eating',    cn: '在吃饭',  audioEn: `${MEDIA_BASE}/w_en_eating.mp3?${V}`,     audioCn: `${MEDIA_BASE}/w_cn_eating.mp3?${V}` },
        // 右视频台词：sleep / sleeping
        { en: 'sleep',     cn: '睡觉',    audioEn: `${MEDIA_BASE}/w_en_sleep.mp3?${V}`,     audioCn: `${MEDIA_BASE}/w_cn_sleep.mp3?${V}` },
        { en: 'sleeping',  cn: '在睡觉',  audioEn: `${MEDIA_BASE}/w_en_sleeping.mp3?${V}`,  audioCn: `${MEDIA_BASE}/w_cn_sleeping.mp3?${V}` },
      ],
    },

    // vocab (3): ick + itch — PPT P10 双视频左右两栏
    {
      label: 'Learn the words (3)',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words3_ick.mp4?${V}`,    poster: `${MEDIA_BASE}/image17.png?${V}` },
        { src: `${MEDIA_BASE}/video_words3_itch.mp4?${V}`,   poster: `${MEDIA_BASE}/image18.png?${V}` },
      ],
      splitAt: 1,
      lines: [
        // 左视频台词：ick
        { en: 'ick',   cn: '呃',   audioEn: `${MEDIA_BASE}/w_en_ick.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_ick.mp3?${V}` },
        // 右视频台词：itch
        { en: 'itch',  cn: '痒',   audioEn: `${MEDIA_BASE}/w_en_itch.mp3?${V}`,  audioCn: `${MEDIA_BASE}/w_cn_itch.mp3?${V}` },
      ],
    },

    // Story 1: drawing / ink
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ii.mp4?${V}`, poster: `${MEDIA_BASE}/image19.png?${V}`, startTime: 27, endTime: 41 }],
      lines: [
        { en: 'In the igloo, Izzie is drawing.', cn: '在冰屋里，Izzie 在画画。',   audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'Ick',                                cn: '呃。',                     audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: "What's wrong Izzie?",               cn: '怎么了 Izzie？',           audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
        { en: 'Oh, no! The ink!',                  cn: '哦不！是墨水！',            audioEn: `${MEDIA_BASE}/story1_en_4.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_4.mp3?${V}` },
      ],
    },

    // Story 2: eating / iguana
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ii.mp4?${V}`, poster: `${MEDIA_BASE}/image20.png?${V}`, startTime: 47, endTime: 62 }],
      lines: [
        { en: 'In the igloo, Izzie is eating.',  cn: '在冰屋里，Izzie 在吃饭。',   audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Ick',                             cn: '呃。',                     audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: "What's wrong Izzie?",            cn: '怎么了 Izzie？',           audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
        { en: 'Oh, no! An iguana!',             cn: '哦不！一只鬣蜥！',          audioEn: `${MEDIA_BASE}/story2_en_4.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_4.mp3?${V}` },
      ],
    },

    // Story 3: sleeping / insect
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ii.mp4?${V}`, poster: `${MEDIA_BASE}/image21.png?${V}`, startTime: 69, endTime: 82 }],
      lines: [
        { en: 'In the igloo, Izzie is sleeping.', cn: '在冰屋里，Izzie 在睡觉。',  audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'Itch',                              cn: '痒。',                    audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: "What's wrong Izzie?",              cn: '怎么了 Izzie？',          audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3?${V}` },
        { en: 'Oh, no! An insect!',               cn: '哦不！一只昆虫！',          audioEn: `${MEDIA_BASE}/story3_en_4.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_4.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
